import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitUpdateFailedAction = {
	type: 'AI_COST_LIMIT_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitUpdateFailedAction => ({
	type: 'AI_COST_LIMIT_UPDATE_FAILED',
	payload,
});
